const MAILER_API = `${process.env.GATSBY_MAILER_API}`;

export const preFetch = () => fetch(MAILER_API);
